import { render } from "./ApiModeWrapper.vue?vue&type=template&id=3ebd8782"
import script from "./ApiModeWrapper.vue?vue&type=script&lang=js"
export * from "./ApiModeWrapper.vue?vue&type=script&lang=js"

import "./ApiModeWrapper.vue?vue&type=style&index=0&id=3ebd8782&lang=sass"

import exportComponent from "C:\\Riman\\Web\\Alex\\ars\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__